const config: { [key: string]: any } = {};

export function setAppConfiguration(key: string, value: any) {
  config[key] = value;
}

export function getAppConfiguration(key: string) {
  return config[key];
}
